import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { LogoSvg } from 'components/icons';
import { HoverEffect } from './atoms';
import { SecondaryTextSm, Empty, FilterCounter } from 'atoms';
import { FlexCenterWrapper, Mr2, Ml2 } from 'wrappers';

const template = styled.div`
  ${({ displayState }) => css`
    position: relative;
    border-radius: 60px;
    padding: ${displayState?.big ? '8px 16px' : '4px 16px'};
    display: flex;
    align-items: center;
    justify-content: ${displayState?.justifyContent ?? ''};
    overflow: hidden;
    cursor: pointer;
    border: 1px solid  ${displayState?.borderColor ? displayState?.borderColor : '#E3E3E3'};
    font-size: 16px;
    background-color: #FFFFFF;

    ${displayState?.disabled && css`
      cursor: not-allowed;
      opacity: .4;
    `}

    svg {
      width: 14px;
      height: 12px;
    }

    span {
      display: none;
    }

    &:hover {
      border: 1px solid ${window?.settings?.secondary_color ?? '#04333b'};
      span {
        display: unset;
      }
    }

    @media only screen and (min-width: 768px) {
      font-size: 14px;
    }
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: HoverEffect,
      name: 'HoverEffect',
      displayValue: () => LogoSvg({})
    },
    {
      wrapper: FlexCenterWrapper,
      name: 'Wrapper',
      atoms: [
        {
          component: wrap(Empty, Mr2),
          name: 'Icon',
          renderIf: ({ icon }) => !!icon,
          displayValue: ({ icon }) => icon ?? null,
        },
        {
          component: SecondaryTextSm,
          name: 'Button',
          displayValue: ({ title }) => title,
        },
        {
          component: wrap(FilterCounter, Ml2),
          name: 'Count',
          renderIf: ({ count }) => !!count,
          displayValue: ({ count }) => count,
          displayState: ({ }) => ({ backgroundColor: window?.settings?.secondary_color ?? '#04333b' })
        },
      ]
    }
  ]
})